import { differenceInCalendarDays, format, isSameDay } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function formatCrmDateTime(dateStr: string): string {
    try {
        return format(new Date(dateStr), "dd/MM/yyyy - HH:mm'h'", { locale: ptBR });
    } catch {
        return dateStr;
    }
}

/// Para o topo do card, onde a data divide a linha com o status: o ano só aparece se não for o atual.
export function formatCrmShortDateTime(dateStr: string, today: Date = new Date()): string {
    try {
        const date = new Date(dateStr);
        const pattern = date.getFullYear() === today.getFullYear()
            ? "dd/MM - HH:mm'h'"
            : "dd/MM/yyyy - HH:mm'h'";

        return format(date, pattern, { locale: ptBR });
    } catch {
        return dateStr;
    }
}

/// Dentro de uma conversa o dia já está no separador acima do grupo; repeti-lo afogaria o texto.
export function formatCrmTime(dateStr: string): string {
    try {
        return format(new Date(dateStr), 'HH:mm', { locale: ptBR });
    } catch {
        return dateStr;
    }
}

export function formatCrmDayLabel(dateStr: string): string {
    try {
        const data = new Date(dateStr);
        const days = differenceInCalendarDays(new Date(), data);

        if (days === 0) return 'Hoje';
        if (days === 1) return 'Ontem';
        if (days < 7) return format(data, 'EEEE', { locale: ptBR });

        return format(data, "d 'de' MMMM", { locale: ptBR });
    } catch {
        return dateStr;
    }
}

/// A lista tem coluna estreita: quanto mais velha a conversa, menos precisão o horário precisa.
export function formatCrmListTime(dateStr: string): string {
    try {
        const data = new Date(dateStr);
        const now = new Date();

        if (isSameDay(now, data)) return format(data, 'HH:mm', { locale: ptBR });

        const days = differenceInCalendarDays(now, data);

        if (days === 1) return 'ontem';
        if (days < 7) return format(data, 'EEE', { locale: ptBR });

        return format(data, 'dd/MM', { locale: ptBR });
    } catch {
        return dateStr;
    }
}

/// Mensagens do mesmo remetente em pouco tempo são uma fala só.
export function sameGroupingWindow(previous: string, current: string): boolean {
    try {
        const a = new Date(previous).getTime();
        const b = new Date(current).getTime();

        return Math.abs(b - a) < 5 * 60 * 1000;
    } catch {
        return false;
    }
}

export function sameDay(previous: string, current: string): boolean {
    try {
        return isSameDay(new Date(previous), new Date(current));
    } catch {
        return false;
    }
}

/// O dia no fuso de quem usa (AAAA-MM-DD), para o link da agenda; o ISO vem em UTC.
export function localDayKey(dateStr: string): string {
    const date = new Date(dateStr);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${date.getFullYear()}-${month}-${day}`;
}
